import { PRODUCTION_BASE_URL, TESTING_BASE_URL } from './ZupplerMenu.constants';
export function getBaseUrl() {
  if (process.env.FAST_ENV === 'production') {
    return PRODUCTION_BASE_URL;
  }
  return TESTING_BASE_URL;
}